<template>
  <CollectionsBody/>
</template>

<script>
// @ is an alias to /src
import CollectionsBody from '@/components/CollectionsBody.vue'

export default {
  name: 'CollectionsView',
  components: {
    CollectionsBody
  }
}
</script>
